import { getCountryDateProfile } from './resolve/getCountryDateProfile'
import { resolveDateRules } from './resolve/resolveDateRules'
import { resolveOperatingHours } from './resolve/resolveOperatingHours'
import { resolveServiceRules } from './resolve/resolveServiceRules'

import type {
  BusinessRuleContext,
  BusinessRules,
} from '@ngb-frontend/shared/types'

/**
 * Single entry point to the centralized business rules. Components should
 * consume this through the `useBusinessRules` hook and branch on resolved
 * capabilities — never on country or brand identifiers.
 */
export const createBusinessRules = (
  ctx: BusinessRuleContext,
): BusinessRules => ({
  dates: (feature) => resolveDateRules(ctx, feature),
  operatingHours: (services, journey) =>
    resolveOperatingHours(
      getCountryDateProfile(ctx.countryCode),
      services,
      journey ?? ctx.journey,
    ),
  services: (query) => resolveServiceRules(ctx, query),
})
